const nippleRetraction = [

    {label:"Side",
    controlType:"radio button",
    options:["Right", "Left", ]
    },

 
    {label:"Surrounding inflammation",
    controlType:"radio button",
    options:["Yes", "No"]
    },

    {label:"Underlying lump",
    controlType:"radio button",
    options:["Yes", "No"]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }

]

export default nippleRetraction

